module.exports = __webpack_public_path__ + "img/nav_icon_fast_s.f219ba1d.svg";